import { render, staticRenderFns } from "./agentQyApprove.vue?vue&type=template&id=0fc0c0b6&scoped=true"
import script from "./agentQyApprove.vue?vue&type=script&lang=js"
export * from "./agentQyApprove.vue?vue&type=script&lang=js"
import style0 from "./agentQyApprove.vue?vue&type=style&index=0&id=0fc0c0b6&prod&scoped=true&lang=css"
import style1 from "./agentQyApprove.vue?vue&type=style&index=1&id=0fc0c0b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0c0b6",
  null
  
)

export default component.exports